import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import Login from "pages/login";
import Dashboard from "pages/dashboard";
import CategoryManagement from "pages/category-management";
import CustomerManagement from "pages/customer-management";
import ProductCatalogManagement from "pages/product-catalog-management";
import OrderManagement from "pages/order-management";
import AddProduct from "pages/add-product";
import AddCategory from "pages/add-category";
import NotFound from "pages/NotFound";
import CustomerFeedbackManagement from "pages/customer-feedback-management";
import PrivacyPolicyManagement from "pages/privacy-policy-management";
import StoreInformationManagement from "pages/store-information-management";
import AdvertisementManagement from "pages/advertisement-management";
import CouponManagement from "pages/coupon-management";
import AdminDashboard from "pages/AdminDashboard";
//
import { LanguageProvider, useLanguage } from "./LanguageContext";
import Layout from "./components/layout/Layout";
import Homepage from "pages/Homepage";
import EditProduct from "pages/edit-product";

const Routes = () => {
//  const { direction } = useLanguage();
  const [isOpen, setIsOpen] = useState(false); // State to manage sidebar open/close

/*  useEffect(() => {
    alert(direction)
    document.documentElement.dir = direction; // Set the document direction
  }, [direction]);*/

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here 
          <Route path="/" element={<Homepage />} />*/}
           <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/category-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <CategoryManagement />
              </Layout>
            }
          />
          <Route
            path="/customer-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <CustomerManagement />
              </Layout>
            }
          />
          <Route
            path="/product-catalog-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <ProductCatalogManagement />
              </Layout>
            }
          />
            <Route
            path="/edit-product"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <EditProduct />
              </Layout>
            }
          />
          <Route
            path="/order-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <OrderManagement />
              </Layout>
            }
          />
          <Route
            path="/add-product"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AddProduct />
              </Layout>
            }
          />
          <Route
            path="/add-category"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AddCategory />
              </Layout>
            }
          />
          <Route
            path="/privacy-policy-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <PrivacyPolicyManagement />
              </Layout>
            }
          />
          {/* <Route
            path="/customer-feedback-management"
            element={<CustomerFeedbackManagement />*/}
          <Route
            path="/admin-dashboard"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AdminDashboard />
              </Layout>
            }
          />

          <Route
            path="/store-information-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <StoreInformationManagement />
              </Layout>
            }
          />
          <Route
            path="/advertisement-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <AdvertisementManagement />
              </Layout>
            }
          />
          <Route
            path="/coupon-management"
            element={
              <Layout isOpen={isOpen} onClose={toggleSidebar}>
                <CouponManagement />
              </Layout>
            }
          />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

const App = () => (
  <LanguageProvider>
    <Routes />
  </LanguageProvider>
);

export default App;
